export default {
  // sidebar 是否收起
  sidebarCollapse: state => state.settings.sidebarCollapse,
  // 是否显示logo
  showLogo: state => state.settings.showLogo,
  // 设备
  device: state => state.app.device,
  // 活动的菜单项的index
  activeIndex: state => state.app.activeIndex,
  // 固定头部
  fixedHeader: state => state.settings.fixedHeader,
 
  //获取用户信息
  getUserInfo: state => {
    if (!state.user) {
      state.user = JSON.parse(sessionStorage.getItem("user"));
    }
    return state.user;
  },
  //  // 用户菜单栏列表
  //  menuList: state => state.menu.menuList,
  //  // 所有菜单的名称
  //  menuName: state => state.menu.menuName,
  //   // 用户所有的权限按钮
  // authButton: state => state.menu.authButton,
};
